import { getExtendedProductScopeUsOrGlobal } from '@discover-frontend/utils';

const AI_QUERY_BUILDER_ADDON_SLUG = 'ai_qb';

export const mapMyCompanyAiQueryBuilderAddon = (companyData) => {
  if (!companyData?.products?.length) return { hasAiQueryBuilder: false };

  const product = companyData.products.find(
    (p) => p.slug === getExtendedProductScopeUsOrGlobal()
  );

  if (!product?.addons?.length) return { hasAiQueryBuilder: false };

  const hasAiQueryBuilder = product.addons.some(
    (addon) => addon?.slug === AI_QUERY_BUILDER_ADDON_SLUG
  );

  return { hasAiQueryBuilder };
};
